import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


const Admin = (props) => {      
    return (
        <>
            <div>Admin page</div>
        </>
    )
};

export default connect()(Admin);
